<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}->{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="生成任务设置" name="first">
                <child1></child1>    
            </el-tab-pane>

            <el-tab-pane label="学生积分设置" name="second">
                <child2></child2>    
            </el-tab-pane>

            <el-tab-pane label="推送设置" name="three">
                <child3></child3>    
            </el-tab-pane>

            <el-tab-pane label="日常考评加减分设置" name="four">
                <child4></child4>    
            </el-tab-pane>

            <el-tab-pane label="钉钉考勤减分设置" name="seven">
                <child7></child7>    
            </el-tab-pane>

            <el-tab-pane label="校长报告设置" name="five">
                <child5></child5>    
            </el-tab-pane>

            <el-tab-pane label="班级报告设置" name="eight">
                <child8></child8>    
            </el-tab-pane>

            <el-tab-pane label="公共参数设置" name="six" v-if="isAdmin">
                <child6></child6>    
            </el-tab-pane>

        </el-tabs>
    </div>
</template>

<script>
    import taskConfig from './task/TaskConfig.vue'
    import pushSet from './task/PushSet.vue'
    import commonSet from './studentSet/CommonSet.vue'
    import teacherDailyEvaluateSet from './teacherEvaluateSet/list.vue' // 教师日常考评加减分设置
    import headMaster from './headMaster/list.vue'  // 校长报告设置
    import classConfig from './classConfig/list.vue'  // 班级报告设置
    import publicParam from './publicParam/index.vue' // 公共参数设置
    import dingdingAttendance from './dingdingAttendance/list.vue' // 钉钉考勤减分设置

    export default {
        name:"ParamSet",
        components:{
            child1:taskConfig,
            child2:commonSet,
            child3:pushSet,
            child4:teacherDailyEvaluateSet,
            child5:headMaster,
            child6:publicParam,
            child8:classConfig,
            child7:dingdingAttendance,
        },
        data() {
            return {
                menuName: "",
                //默认第一个选项卡
                activeName: "second",
                title: "学生积分设置",
                isAdmin: false,
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            // 用户信息
            let userinfo =JSON.parse(sessionStorage.getItem('userinfo'));
            // 如果id为1的话，表示管理员，管理才能设置公共参数
            if(userinfo.id == 1){
                this.isAdmin=true;
            }else{
                this.isAdmin=false;
            }
        },
        methods:{
            handleClick(tab) {
                if(tab.name == "first") {
                    this.title="生成任务设置";
                }else if(tab.name == "second") {
                    this.title="学生积分设置";
                }else if(tab.name == "three") {
                    this.title="推送设置";
                }else if(tab.name == "four") {
                    this.title="日常考评加减分设置";
                }else if(tab.name == "five") {
                    this.title="校长报告设置";
                }else if(tab.name == "eight") {
                    this.title="班级报告设置";
                }else if(tab.name == "six") {
                    this.title="公共参数设置";
                }else if(tab.name == "seven") {
                    this.title="钉钉考勤减分设置";
                }
            }
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/ParamSet.vue